import type { SimpleBounds } from '@/types';

export const doBoundsIntersect = (b1: SimpleBounds, b2: SimpleBounds): boolean => {
  return b1.minX < b2.maxX && b1.maxX > b2.minX && b1.minY < b2.maxY && b1.maxY > b2.minY;
};
